import { AxiosDeleteToken, AxiosPostFormDataToken } from "./AxiosCall";

export const UploadImgApi = async ({ file }) => {
  let formData = new FormData();
  formData.append("img", file);
  try {
    let res = await AxiosPostFormDataToken("upload-img", formData);
    return res;
  } catch (error) {
    return error;
  }
};


export const DeleteImgApi = async ({ name }) => {
  try {
    let res = await AxiosDeleteToken("upload-img/"+name);
    return res;
  } catch (error) {
    console.log('error',error)
    return error;
  }
};
